import { TListResponse } from '.';
import { ApiData, ChartApiData } from '/src/lib/models';

// UI types
export enum ApiDataViewType {
  station,
  session,
  chart,
}

export enum ApiDataChartTimeframe {
  days = 'days',
  months = 'months',
  quarters = 'quarters',
  years = 'years',
}

export enum ApiDataChartRangePreset {
  currentPage = 'current',
  days90 = 'days90',
  months6 = 'months6',
  year1 = 'year1',
  year2 = 'year2',
  year3 = 'year3',
  year4 = 'year4',
  year5 = 'year5',
  year6 = 'year6',
  year7 = 'year7',
  custom = 'custom',
}

export type ApiDataFilterQueryState = {
  chargingNetwork?: string[];
  subOrganization?: string[];
  serialNumber?: string[];
  state?: string[];
  chargerLevel?: number[];
  startDate?: string;
  endDate?: string;
};

export type RestorableApiDataFilterState = ApiDataFilterQueryState & {
  hasAppliedFilters: boolean;
};

export type ApiDataChartViewQueryState = ApiDataFilterQueryState & {
  timeframe?: ApiDataChartTimeframe;
  rangePreset?: ApiDataChartRangePreset;
};

export type ApiDataTableViewQueryState = ApiDataFilterQueryState & {
  page: number;
  search: string;
  per_page: number;
  order_by: string | undefined;
  order_direction: string | undefined;
};

/**
 * List Data
 */
export type TListApiDataRequest = {
  view_type: 'charger' | 'session';
  per_page: number;
  page: number;
  order_by?: string;
  order_direction?: 'asc' | 'desc';
  search?: string;
  chargingNetwork?: string[];
  subOrganization?: string[];
  serialNumber?: string[];
  state?: string[];
  chargerLevel?: number[];
  startDate?: string;
  endDate?: string;
};

export type TListApiDataResponse = TListResponse<ApiData[]>;

/**
 * Filters Values
 */
export type TFilterValue = { label: string; value: string };

export type TFiltersApiDataRequest = {
  chargingNetwork?: string[];
  subOrganization?: string[];
  state?: string[];
  chargerLevel?: number[];
};

export type TFiltersApiDataValues<T> = {
  has_null: boolean;
  values: T[];
};

export type TFiltersApiDataResponse = {
  chargingNetwork: string[];
  subOrganization?: string[];
  serialNumber?: string[];
  state: string[];
  chargerLevel?: number[];
  startDate: string;
  endDate: string;
};

/**
 * Available Columns
 */
export type TColumnsApiDataResponse = { chargers: string[]; sessions: string[] };

/**
 * Download data
 */

export type TDownloadApiDataRequest = {
  view_type: 'charger' | 'session';
  order_by?: 'name' | 'start_date';
  order_direction?: 'asc' | 'desc';
  search?: string;
  chargingNetwork?: string[];
  subOrganization?: string[];
  serialNumber?: string[];
  state?: string[];
  chargerLevel?: number[];
  startDate?: string;
  endDate?: string;
};

export type TDownloadApiDataLinkResponse = { url: string };

export type TDownloadApiDataResponse = string;

/**
 * Chart Data
 */
export type TChartApiDataRequest = Omit<TListApiDataRequest, 'per_page' | 'page' | 'view_type'> & {
  timeframe?: string;
  startDate?: string;
  endDate?: string;
  viewStations?: string[];
};

export type TChartApiDataResponse = { dateChart: ChartApiData; stationChart: ChartApiData };
